/* RESPONSIBLE TEAM: team-ml */

import { default as OriginalRoute } from 'embercom/routes/apps/app/automation/workflows/edit';
import { inject as service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';
import type AppService from 'embercom/services/app-service';
import type Transition from '@ember/routing/transition';
import { get } from 'embercom/lib/ajax';

export default class Route extends OriginalRoute {
  @service declare router: RouterService;
  @service declare appService: AppService;

  controllerName = 'apps/app/automation/workflows/edit';

  async beforeModel(transition: Transition) {
    if (this.appService.app.canUseStandalone) {
      let params = transition.to.params;
      if (params.id) {
        this.router.transitionTo('apps.app.standalone.tasks.workflow', params.id);
        return;
      }
    }
    if (this.appService.app.canUseFinProceduresDedicatedPage) {
      let params = transition.to.params;
      if (params.id) {
        try {
          let response = await get('/ember/procedures', {
            app_id: this.appService.app.id,
            ruleset_id: params.id,
          });
          this.router.transitionTo(
            'apps.app.automation.fin-ai-agent.procedures.procedure',
            (response as { id: string }).id,
          );
          return;
        } catch {
          // If lookup fails (e.g., not a valid procedure), fall through to original behavior
        }
      }
    }

    super.beforeModel(transition);
  }

  titleToken(model: $TSFixMe): string | null {
    let taskTitle = model?.humanReadableTitle;
    if (taskTitle) {
      return taskTitle;
    }
    return null;
  }
}
